import { statisticsOption } from './statistics'
import { equityOption } from './equity'
import { incomeOption } from './income'

function deepCopy(obj, cache = []) {
    function find(list, f) {
        return list.filter(f)[0]
    }

    // just return if obj is immutable value
    if (obj === null || typeof obj !== 'object') {
        return obj
    }

    // if obj is hit, it is in circular structure
    const hit = find(cache, c => c.original === obj)
    if (hit) {
        return hit.copy
    }

    const copy = Array.isArray(obj) ? [] : {}
    // put the copy into cache at first
    // because we want to refer it in recursive deepCopy
    cache.push({
        original: obj,
        copy
    })

    Object.keys(obj).forEach(key => {
        copy[key] = deepCopy(obj[key], cache)
    })

    return copy
}

function getChartOption(chartName, chartData) {
    let option = null
    let min = 0
    let max = 999
    switch (chartName) {
        case "grid":
            option = statisticsOption

            option.title.text = chartData['sName']

            option.xAxis.data = chartData['xData']
            option.xAxis.axisLabel.rotate = 0
            option.yAxis.name = chartData['yName']
            option.yAxis.minInterval = chartData['minInterval']

            var data = chartData['data'];

            var legend = [];

            option.series = [];
            var count = data.length
            for (var i = 0; i < count; i++) {

                var w = data[i].length;
                w = w * 5

                option.series.push({
                    type: 'bar',
                    //barGap: 5,
                    name: chartData['name'][i],
                    barWidth: w + "%",
                    label: {
                        show: true,
                        position: 'top',
                        textStyle: {
                            color: '#666'
                        }
                    },
                    
                    color: chartData['color'][i],
                    markPoint: {
                        symbol: chartData['markPoint']['symbol'],
                        itemStyle: {
                            color: chartData['markPoint']['color']
                        },
                        data: chartData['markPoint']['data']
                    },
                    data: data[i]
                });

                legend.push(chartData['name'][i]);
            }

            option.legend.data = legend;

            break;
        case "statistics":
            option = statisticsOption

            option.title.text = chartData['sName']

            option.legend.data = [];
            
            option.xAxis.data = chartData['xData']
            option.xAxis.axisLabel.rotate = 30
            option.yAxis.name = chartData['yName']
            option.yAxis.minInterval = chartData['minInterval']

            var w = chartData['data'].length;
            w = w * 5
            option.series[0].barWidth = w + "%";
            option.series[0].color = chartData['color']
            option.series[0].data = chartData['data']

            option.series[0].markPoint.symbol = chartData['markPoint']['symbol']
            option.series[0].markPoint.itemStyle.color = chartData['markPoint']['color']
            option.series[0].markPoint.data = chartData['markPoint']['data']
            break;
        case "income":
            option = incomeOption

            option.title.text = chartData['sName']

            option.xAxis[0].name = chartData['xName']
            option.xAxis[0].data = chartData['xData']
            option.yAxis[0].name = chartData['yName']

            var data = chartData['data'];

            option.series = [];
            var legend = [];
            var count = data.length
            for (var i = 0; i < count; i++) {
                option.series.push({
                    smooth: false,
                    name: data[i].name,
                    type: 'line',
                    color: data[i].color,
                    symbol: 'none',
                    data: data[i].data
                });

                legend.push(data[i].name);
            }

            option.legend.data = legend;

            break;
        case "equity":
            option = equityOption

            option.title.text = chartData['sName']

            option.xAxis[0].name = chartData['xName']
            option.xAxis[0].data = chartData['xData']

            min = 0
            max = 999
            var originFund = 0;

            var data = chartData['data'];

            var legend = [];
            var count = data.length
            for (var i = 0; i < count; i++) {
                option.series[i].name = data[i].name
                option.series[i].data = data[i].data == null ? [] : data[i].data;
                
                legend.push(data[i].name);
                
                if (option.series[i].data.length > 0) {
                    if (min == 0 || Math.min.apply(null, option.series[i].data) < min)
                        min = Math.min.apply(null, option.series[i].data)
                    if (max == 0 || Math.max.apply(null, option.series[i].data) > max)
                        max = Math.max.apply(null, option.series[i].data)

                    if (data[i].type === 1) {
                        originFund = data[i].data[0]
                        option.series[i].markLine.data[0].yAxis = originFund
                    }
                }
            }

            option.legend.data = legend;

            min = parseInt(Math.floor(min));
            max = parseInt(Math.ceil(max));
            
            if ((Math.abs(min)).toString().length > 1) {
                if (originFund != undefined) originFund = parseInt(originFund.toString());

                var len = Math.abs(originFund);
                len = len.toString().length - 2;

                len = Math.pow(10, len)
                len = parseInt(len.toString())

                if (min < 0) {
                    min = 0;
                } else {
                    min = parseInt(min / len) * len;
                }

                max = parseInt(max / len + 1) * len;
            }

            option.yAxis[0].min = min
            option.yAxis[0].max = max
            break;
        
    }
    return deepCopy(option)
}

export { getChartOption }